import { profileVerificationActionTypes } from '../actions/profileVerificationActions';

const initialState = {
  user: null,
};

export default function profileVerificationReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case profileVerificationActionTypes.SET_PROFILE_TO_VERIFY: {
      return { ...state, user: action.payload };
    }
    default:
      return state;
  }
}
